export const isStringNullOrWhiteSpace = (str: string | null | undefined): boolean => !str || /^\s*$/.test(str);
